import src from "IMAGE";
export default { src, width: 419, height: 378, blurWidth: 0, blurHeight: 0};
